
import React, { useState, useEffect, useRef, useCallback, useMemo } from 'react';
import { AgGridReact } from 'ag-grid-react';

import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';
import CONSTANTS from '../util/constants';
import { useDispatch, useSelector } from 'react-redux';
import ModalComponent from './ModalComponent';
import { DataInput } from './DataComponent';
import * as XLSX from 'xlsx';
import Encrypt from './../util/encrypt';

const DivisionsComp = () => {
    const gridRef = useRef();
    const dispatch = useDispatch();
    let rowData = useSelector((state) => state.division.getDivisionData);
    rowData = rowData.filter((data,i)=>{
        return data?.is_active === true
     })
    const [modalShow, isModalShow] = useState(false);
    const [cellData, setCellClickData] = useState(null);
    const [rowDataDivision, setRowDataDivision] = useState();
    const [loginResponse, setLoginResponse] = useState(null);


    useEffect(() => {

        let localstorageLR = localStorage.getItem("L_R");
        if (localstorageLR) {
            let data = localstorageLR ? Encrypt.dycryptData(localstorageLR) : ''
            let loginResponse = localstorageLR ? (JSON.parse(data) != "" || JSON.parse(data) != null) ? JSON.parse(data) : '' : '';
            setLoginResponse(loginResponse);
        }

        setCellClickData(null);

        dispatch({
            type: CONSTANTS.CONSTANTS_DIVISIONS_MANAGEMENT.GET_DIVISIONS_MANAGEMENT_API_CALL
        })

    }, []);

    useEffect(() => {
        if (rowData && rowData != null) {
            let rowDataActive = rowData?.filter((item) => item.is_active == true)
            setRowDataDivision(rowDataActive);
        }
    }, [rowData]);

    useEffect(() => {
        setColumnDefs([
            { headerName: 'Division No', field: 'division_id', filter: true, resizable: true, flex: 1 },
            { headerName: 'Division Name', field: 'divisionName', filter: true, resizable: true, flex: 1 },
            {
                headerName:
                    loginResponse && ((loginResponse?.user?.userRoles[0]?.user_role_name == CONSTANTS.CONSTANTS_USER_ROLES.ADMIN && loginResponse?.user?.userRoles[0]?.priority) || (loginResponse?.user?.userRoles[0]?.user_role_name == CONSTANTS.CONSTANTS_USER_ROLES.RHADMIN && loginResponse?.user?.userRoles[0]?.priority)) ?
                        'Actions' : '', filter: true, resizable: true, flex: 1
                , children: [
                    {
                        field: '', filter: true, resizable: true, flex: 1, cellRenderer: cellImageRender, width: 100,
                        minWidth: 100,
                        maxWidth: 200
                    },
                    {
                        field: '', filter: true, resizable: true, flex: 1, cellRenderer: cellCancelImageRender, width: 100,
                        minWidth: 150,
                        maxWidth: 200
                    }
                ]


            },

        ])
    }, [loginResponse])

    const cellImageRender = (params) => {

        return (
            loginResponse && ((loginResponse?.user?.userRoles[0]?.user_role_name == CONSTANTS.CONSTANTS_USER_ROLES.ADMIN && loginResponse?.user?.userRoles[0]?.priority) || (loginResponse?.user?.userRoles[0]?.user_role_name == CONSTANTS.CONSTANTS_USER_ROLES.RHADMIN && loginResponse?.user?.userRoles[0]?.priority)) ?

                <div onClick={() => {
                    showModal(true);
                    setCellClickData(params.data);
                }}>
                    <img style={{ marginLeft: 20 }} src={require('./../assets/Dashboard/actions.png')} />
                </div>
                : null

        );
    };

    const cellCancelImageRender = (params) => {

        return (
            loginResponse && ((loginResponse?.user?.userRoles[0]?.user_role_name == CONSTANTS.CONSTANTS_USER_ROLES.ADMIN && loginResponse?.user?.userRoles[0]?.priority) || (loginResponse?.user?.userRoles[0]?.user_role_name == CONSTANTS.CONSTANTS_USER_ROLES.RHADMIN && loginResponse?.user?.userRoles[0]?.priority)) ?

                <div onClick={() => {
                    setCellClickData(params.data);
                    let obj = { 'division_id': params.data.division_id, 'divisionName': params.data.divisionName, "is_active": false }
                    dispatch({
                        type: CONSTANTS.CONSTANTS_DIVISIONS_MANAGEMENT.EDIT_DIVISIONS_MANAGEMENT_API_CALL, payload: { value: obj }
                    })
                }}>
                    <img style={{ marginLeft: 20 }} src={require('./../assets/Dashboard/cancel.png')} />
                </div>

                : null
        );
    };

    const [columnDefs, setColumnDefs] = useState([])

    const defaultColDef = useMemo(() => ({
        sortable: true,
        resizable: true,
    }));

    const buttonListener = useCallback(e => {
        gridRef.current.api.deselectAll();
    }, []);

    const cellClickedListener = useCallback(event => {
    }, []);

    const showModal = (isShow) => {
        isModalShow(isShow);
    }

    const paginationNumberFormatter = useCallback((params) => {
        return '[' + params.value.toLocaleString() + ']';
    }, []);

    const onGridReady = useCallback((params) => {
        dispatch({
            type: CONSTANTS.CONSTANTS_TRAILER_MANAGEMENT.GET_TRAILER_MANAGEMENT_API_CALL
        })
    }, []);

    const onFirstDataRendered = useCallback((params) => {
        gridRef.current.api.paginationGoToPage(1);
    }, []);

    const importDivision = (file) => {

        const reader = new FileReader();
        const rABS = !!reader.readAsBinaryString;
        reader.onload = e => {
            /* Parse data */
            const bstr = e.target.result;
            const wb = XLSX.read(bstr, { type: rABS ? "binary" : "array" });
            /* Get first worksheet */
            const wsname = wb.SheetNames[0];
            const ws = wb.Sheets[wsname];
            /* Convert array of arrays */
            const data = XLSX.utils.sheet_to_json(ws, { header: 0 });
            /* Update state */
            if (data && data.length > 0) {
                let payload = [];
                for (let i = 0; i < data.length; i++) {
                    payload.push({ divisionName: data[i].divisionName })
                }
                dispatch({
                    type: CONSTANTS.CONSTANTS_WORKSHEET_MANAGEMENT.DIVISION_BULK_API_CALL, payload: { value: payload }
                })
            }
            else {
                alert('Failed to load data')
            }
        };
        if (rABS) reader.readAsBinaryString(file);
        else reader.readAsArrayBuffer(file);
    }

    return (
        <div className='row'>
            {modalShow ? <ModalComponent
                title={cellData != null ? 'Edit Division' : 'Add Division'}
                show={showModal}
                handleClose={showModal}
                divisionManagement={true}
                isShow={showModal}
                rowDataDivision={cellData}
                setValue={(value) => {
                    isModalShow(false);
                    if (cellData != null) {
                        setCellClickData(null);
                        dispatch({
                            type: CONSTANTS.CONSTANTS_DIVISIONS_MANAGEMENT.EDIT_DIVISIONS_MANAGEMENT_API_CALL, payload: { value: value }
                        })
                    }
                    else {

                        dispatch({
                            type: CONSTANTS.CONSTANTS_DIVISIONS_MANAGEMENT.ADD_DIVISIONS_MANAGEMENT_API_CALL, payload: { value: value }
                        })
                    }
                }}
            /> : null}

            <div className='col-md-12 col-sm-12 col-12'>
                {
                    loginResponse && ((loginResponse?.user?.userRoles[0]?.user_role_name == CONSTANTS.CONSTANTS_USER_ROLES.ADMIN && loginResponse?.user?.userRoles[0]?.priority)) ?
                        <div className="col-md-12 col-sm-12 row-4 icon icon-shape icon-l  me-12" style={{ width: '100%', display: 'flex', justifyContent: 'flex-start', alignItems: 'flex-start', margin: '2px 0 2px 0px' }}>
                            <DataInput handleFile={importDivision} />
                        </div>

                        : null
                }

                {
                    loginResponse && ((loginResponse?.user?.userRoles[0]?.user_role_name == CONSTANTS.CONSTANTS_USER_ROLES.ADMIN && loginResponse?.user?.userRoles[0]?.priority) || (loginResponse?.user?.userRoles[0]?.user_role_name == CONSTANTS.CONSTANTS_USER_ROLES.RHADMIN && loginResponse?.user?.userRoles[0]?.priority)) ?
                        <div className="col-md-12 col-sm-12 row-4 icon icon-shape icon-l  me-12" style={{ width: '100%', display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-end', margin: '2px 0 2px 0px' }}>

                            <img onClick={() => {
                                setCellClickData(null);
                                isModalShow(true);
                            }} src={require('./../assets/Dashboard/plus.png')} style={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'flex-end' }}></img>
                        </div>
                        : null
                }
                <div className="col-md-12 col-sm-12 row-10 ag-theme-alpine" style={{
                    height: '80vh', width: '80vw', margin: 'auto'
                }}>
                    <AgGridReact
                        ref={gridRef}
                        suppressColumnVirtualisation={true}
                        defaultColDef={defaultColDef}
                        animateRows={true}
                        onCellClicked={cellClickedListener}
                        rowData={rowDataDivision}
                        pagination={false}
                        paginationAutoPageSize={false}
                        paginationPageSize={10}
                        paginateChildRows={false}
                        enableRangeSelection={false}
                        suppressRowClickSelection={false}
                        groupSelectsChildren={false}
                        rowSelection={'multiple'}
                        rowGroupPanelShow={'always'}
                        pivotPanelShow={'always'}
                        columnDefs={columnDefs}
                        paginationNumberFormatter={paginationNumberFormatter}
                        onGridReady={onGridReady}
                        onFirstDataRendered={onFirstDataRendered}
                    >
                    </AgGridReact>

                </div>
            </div>
        </div >

    );
};
export default DivisionsComp;
